import request from '@/utils/request'

// 查询气候分页
export function pageClimate(data) {
  return request({
    url: '/cloudplant/climate/page',
    method: 'post',
    data: data
  })
}

// 查询气候列表
export function listClimate(query) {
  return request({
    url: '/cloudplant/climate/list',
    method: 'get',
    params: query
  })
}

// 查询气候详情
export function getClimate(data) {
  return request({
    url: '/cloudplant/climate/detail',
    method: 'get',
    params: data
  })
}

// 新增气候
export function addClimate(data) {
  return request({
    url: '/cloudplant/climate/add',
    method: 'post',
    data: data
  })
}

// 修改气候
export function updateClimate(data) {
  return request({
    url: '/cloudplant/climate/edit',
    method: 'post',
    data: data
  })
}

// 删除气候
export function delClimate(data) {
  return request({
    url: '/cloudplant/climate/delete',
    method: 'post',
    data: data
  })
}
